import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';

interface TableItem {
  list?: TableItem[];
  parentExpanded?: boolean; // 最上层父级展开状态 true 展开 false 收起
  expanded?: boolean; // 当前展开状态 true 展开 false 收起 存在下级是才有此状态
  title?: string;
  value_no?: string;
  levels?: number; // 等级 0~n
  class_code?: string; // 最上层code
}

@DialogFactory
@Component({
  mixins: [style],
})
export default class SelectClassDialog extends IPSDialog {
  title = '选择分类';

  dataList: TableItem[] = [];

  confirm = false;

  attrbuteList = [];

  selectType = 1; // 1添加一级分类 2选择二级分类

  expandCode: string[] = []; // 展开的code

  mounted() {
    this.dataList = cloneDeep(this.attrbuteList);
  }

  /**
   * 行样式 控制显示和不显示
   * @param row
   * @returns {string}
   */
  showTr({ row }): string {
    return this.expandCode.includes(row.class_code) || row.levels === 0 || this.selectType === 2 ? '' : 'display: none';
  }

  /**
   * 单元格样式 控制显示和不显示
   * @param row
   * @returns {string}
   */
  showCell({ row }): string {
    return this.expandCode.includes(row.class_code) || row.levels === 0 || this.selectType === 2 ? '' : 'display: none';
  }

  /**
   * 计算当前行是否展示张开和收起图标
   * @param {TableItem} val
   * @returns {boolean}
   */
  getShowExpandedIcon(val: TableItem): boolean {
    return !val.levels;
  }

  /**
   * 选中分类
   * @param value_no
   * @returns null
   */
  onSelected(value_no: string, title: string): void {
    this.$emit('result', { value_no, title });
    this.$emit('hidden');
  }

  /**
   * 展开
   * @param {string} value_no
   * @returns null
   */
  onExpanded(value_no) {
    const parentClass = this.dataList.find(v => v.value_no === value_no);
    if (parentClass) {
      parentClass.parentExpanded = true;
    }
  }

  /**
   * 收起
   * @param {string} value_no
   */
  onClose(value_no) {
    const parentClass = this.dataList.find(v => v.value_no === value_no);
    if (parentClass) {
      parentClass.parentExpanded = false;
    }
  }

  /**
   * 点击展开和关闭的时候，图标的切换
   * @param {ItemObject} val
   * @return {boolean}
   */
  public toggleIconShow(val: ItemObject): boolean {
    return !!(val.levels === 0 && val.children && val.children.length);
  }

  /**
   * 展开下级
   * @param val
   * @param trIndex
   */
  public expandLevel(val, trIndex: number) {
    if (val.expanded) {
      this.expandCode = this.expandCode.filter(v => v != val.value_no);
    } else {
      this.expandCode.push(val.value_no);
    }
    this.dataList[trIndex].expanded = !this.dataList[trIndex].expanded;
    this.$forceUpdate();
  }

  renderContent(h) {
    return (
      <div class="select-class">
        <el-table data={this.dataList} tooltip-effect="light" height="350px" row-style={this.showTr} cell-style={this.showCell}>
          <el-table-column
            label=""
            prop="title"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return (
                    <span class="r-pl-28">
                      {this.toggleIconShow(scoped.row) && (
                        <span class="absolute" style="left: 12px" onClick={this.expandLevel.bind(this, scoped.row, scoped.$index)}>
                          {!scoped.row.expanded && <i class="el-icon-caret-right" aria-hidden="true" />}
                          {scoped.row.expanded && <i class="el-icon-caret-bottom" aria-hidden="true" />}
                        </span>
                      )}
                      <span style={{ paddingLeft: `${(this.selectType === 2 ? 0 : scoped.row.levels) * 20}px` }}>
                        {scoped.row.title}
                      </span>
                    </span>
                  );
                },
              },
            }}
          />
          <el-table-column
            label=""
            width="80px"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return !!(scoped.row.children && scoped.row.children.length) || this.selectType === 2 ? (
                    <span class="scopeSpan" onClick={this.onSelected.bind(this, scoped.row.value_no, scoped.row.title)}>
                      选中
                    </span>
                  ) : (
                    ''
                  );
                },
              },
            }}
          />
        </el-table>
      </div>
    );
  }
}
